import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { CustomSwitch } from 'components/common/Switch';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import ErrorMessage from 'components/common/ErrorMessage';
import { setError } from 'slices/typeSlice';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import moment from 'moment';
import { Select } from 'components/common/Select';
import { languageTierSelector } from 'slices/languageTierSlice';
import { fetchTemplateLanguagesTiers } from 'slices/languageTierSlice';
import { useNavigate } from 'react-router-dom';
import { updateTemplate } from 'slices/templateSlice';
import { addTemplate } from 'slices/templateSlice';
import FullPageLoader from 'components/common/FullPageLoader';
import { usePermissions } from 'layouts/Admin';



export const filterUnit = [
  {
    label: "Hour",
    value: "hour"
  },
  {
    label: "Minute",
    value: "minute"
  }
]
export const filterIncremental = [
  {
    label: "Minute",
    value: "minute"
  },
  {
    label: "30 Minute",
    value: "30_minute"
  },
  {
    label: "1 Hour",
    value: "1_hour"
  },
]
export const TimeInput = ({ name, rule, control, errors, onChange }) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={{ required: rule }}
      render={({ field }) => (
        <div style={{ width: "100%" }}>
          <div className="input-image">
            <input
              type="time"
              name={name}
              placeholder="hh:mm"
              {...field}
              value={field.value}
              onChange={(e) => {
                field.onChange(e.target.value);
                onChange && onChange(e.target.value);
              }}
            />
            <img src="/images/clock.png" alt="Clock Icon" className="custom-icon" />
          </div>
          {errors?.[name]?.message && (
            <div style={{ marginTop: 10 }}>
              <ErrorMessage text={errors?.[name]?.message} />
            </div>
          )}
        </div>
      )}
    />
  );
};

export const RateInput = ({ errors, name, control, placeholder, currency_symbol = false }) => {
  return (
    <div className="rate-input-wrapper">
      <Controller
        name={name}
        control={control}
        rules={{
          required: "This field is required"
        }}
        render={({ field }) => (
          <div className={`${currency_symbol ? 'input-dollar-group' : ''}`}>
            {currency_symbol && <span className="dollar-prefix">$</span>}
            <input
              className={`input-in type_inp ${currency_symbol ? 'dollar-padding' : ''}`}
              type="number"
              name={name}
              placeholder={placeholder}
              {...field}
              onChange={(e) => {
                const val = parseFloat(e.target.value);
                field.onChange(val < 0 ? 0 : val);
              }}
            />
          </div>
        )}
      />
      {errors?.[name]?.message && (
        <div style={{ marginTop: 10 }}>
          <ErrorMessage text={errors?.[name]?.message} />
        </div>
      )}
    </div>
  );
};


export const UnitSelect = ({ name, control }) => {
  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field }) =>
          <div className='select_box' style={{ width: "100%" }}>
            <Select
              name={name}
              options={filterUnit || []}
              value={field.value ? filterUnit?.find((opt) => field.value == opt.value) : ""}
              isClearable={false}
              disabledSearch={true}
              onChange={(value) => {
                field.onChange(value);
              }}
            />
          </div>
        }
      />
    </>
  )
}
const TemplateTimes = ({ control, errors, error, watch, setValue, languageTiers }) => {


  const handleNormalHoursChange = () => {
    const normalHourStartTime = watch("normal_hour_start_time");
    const normalHourEndTime = watch("normal_hour_end_time");

    if (normalHourStartTime && normalHourEndTime) {
      const normalStart = moment(normalHourStartTime, "HH:mm");
      const normalEnd = moment(normalHourEndTime, "HH:mm");

      const afterStart = moment(normalEnd).add(1, "minutes");
      const afterEnd = moment(normalStart).subtract(1, "minutes").add(1, "day");

      setValue("after_hour_start_time", afterStart.format("HH:mm"));
      setValue("after_hour_end_time", afterEnd.format("HH:mm"));
    }
  };

  const handleAfterHoursChange = () => {
    const afterHourStartTime = watch("after_hour_start_time");
    const afterHourEndTime = watch("after_hour_end_time");

    if (afterHourStartTime && afterHourEndTime) {
      const afterStart = moment(afterHourStartTime, "HH:mm");
      const afterEnd = moment(afterHourEndTime, "HH:mm");

      const normalStart = moment(afterEnd).add(1, "minutes").subtract(1, "day");
      const normalEnd = moment(afterStart).subtract(1, "minutes");

      setValue("normal_hour_start_time", normalStart.format("HH:mm"));
      setValue("normal_hour_end_time", normalEnd.format("HH:mm"));
    }
  };

  const handleChangeMinDuration = (value) => {
    if (value == "minute" || value == "30_minute") {
      languageTiers.forEach((element, index) => {
        setValue(`interpretationRates.opi_normal_mins_time_unit.${index}`, 'minute')
        setValue(`interpretationRates.vri_normal_mins_time_unit.${index}`, 'minute')
        setValue(`interpretationRates.inperson_normal_mins_time_unit.${index}`, 'minute')
        setValue(`interpretationRates.opi_after_mins_time_unit.${index}`, "minute");
        setValue(`interpretationRates.vri_after_mins_time_unit.${index}`, "minute");
        setValue(`interpretationRates.inperson_after_mins_time_unit.${index}`, "minute");
      });
    } else {
      languageTiers.forEach((element, index) => {
        setValue(`interpretationRates.opi_normal_mins_time_unit.${index}`, 'hour')
        setValue(`interpretationRates.vri_normal_mins_time_unit.${index}`, 'hour')
        setValue(`interpretationRates.inperson_normal_mins_time_unit.${index}`, 'hour')
        setValue(`interpretationRates.opi_after_mins_time_unit.${index}`, "hour");
        setValue(`interpretationRates.vri_after_mins_time_unit.${index}`, "hour");
        setValue(`interpretationRates.inperson_after_mins_time_unit.${index}`, "hour");
      });
    }
  }

  return (
    <>
      <div className="row-primary">
        <h2>Name *</h2>
        <div className='w-100'>
          <Controller
            name="name"
            rules={{ required: "Please Enter name" }}
            control={control}
            render={({ field }) => <input className="input-in type_inp" type="text" name='name' placeholder='Template Name' {...field} />}
          />
          {errors?.name?.message && <div style={{ marginTop: 10 }}><ErrorMessage text={errors?.name?.message} /></div>}
          {error?.errors?.name?.map((error) => <div style={{ marginTop: 10 }}><ErrorMessage text={error} /></div>)}
        </div>
      </div>

      {/* Normal Hours */}
      <div className="row-primary m-0 row-r justify-content-between flex-row">
        <h2 className='fst-italic fw-bold mt-0'>Normal Hours </h2>
      </div>
      <div className="foam_page_row">
        <div className="row-primary">
          <h2>Start Time*</h2>
          <TimeInput
            errors={errors}
            control={control}
            name="normal_hour_start_time"
            rule="Please select start time"
            onChange={handleNormalHoursChange}
          />
        </div>

        <div className="row-primary">
          <h2>End Time*</h2>
          <TimeInput
            errors={errors}
            control={control}
            name="normal_hour_end_time"
            rule="Please select End time"
            onChange={handleNormalHoursChange}
          />
        </div>
      </div>

      {/* After Hours */}
      <div className="row-primary m-0 row-r justify-content-between flex-row">
        <h2 className='fst-italic fw-bold mt-0'>After Hours </h2>
      </div>
      <div className="foam_page_row">
        <div className="row-primary">
          <h2>Start Time*</h2>
          <TimeInput
            errors={errors}
            control={control}
            name="after_hour_start_time"
            rule="Please select start time"
            onChange={handleAfterHoursChange}
          />
        </div>

        <div className="row-primary">
          <h2>End Time*</h2>
          <TimeInput
            errors={errors}
            control={control}
            name="after_hour_end_time"
            rule="Please select End time"
            onChange={handleAfterHoursChange}
          />
        </div>
      </div>

      {/* Grace Period */}
      <div className='foam_page_row mt-3'>
        <div className="row-primary">
          <h2>Cancellation Grace Period(Hrs) *</h2>
          <div style={{ width: "100%" }}>
            <Controller
              name="grace_period"
              control={control}
              rules={{ required: "Please enter grace period" }}
              render={({ field }) => (
                <input className="input-in type_inp" type="number" name='grace_period' placeholder='Grace Period' {...field}
                  onChange={
                    (e) => {
                      field.onChange(parseFloat(e.target.value));
                      if (e.target.value < 0) {
                        field.onChange(0);
                      }
                    }
                  }
                />
              )}
            />
            {errors?.grace_period?.message &&
              <div style={{ marginBottom: 10 }}>
                <ErrorMessage text={errors?.grace_period?.message} />
              </div>
            }
          </div>
        </div>
        
        <div className="row-primary">
          <h2>Incremental *</h2>
          <Controller
            name="incremental"
            control={control}
            render={({ field }) =>
              <div className='select_box' style={{ width: "100%" }}>
                <Select
                  name="incremental"
                  options={filterIncremental || []}
                  value={field.value ? filterIncremental?.find((opt) => field.value == opt.value) : ""}
                  isClearable={false}
                  disabledSearch={true}
                  onChange={(value) => {
                    field.onChange(value);
                    handleChangeMinDuration(value);
                  }}
                />
              </div>
            }
          />
        </div>
      </div>

      {/* Rush Fee  */}
      <div className='foam_page_row mt-3'>
        <div className="row-primary">
          <h2>Rush Fee *</h2>
          <div style={{ width: "100%" }}>
            <Controller
              name="rush_fee"
              control={control}
              rules={{ required: "Please enter rush fee" }}
              render={({ field }) => (
                <input className="input-in type_inp" type="number" name='rush_fee' placeholder='Rush fee' {...field}
                  onChange={
                    (e) => {
                      field.onChange(parseFloat(e.target.value));
                      if (e.target.value < 0) {
                        field.onChange(0);
                      }
                    }
                  }
                />
              )}
            />
            {errors?.rush_fee?.message &&
              <div style={{ marginBottom: 10 }}>
                <ErrorMessage text={errors?.rush_fee?.message} />
              </div>
            }
          </div>
        </div>
      </div>
    </>
  );
};
const LanguageTiers = ({ languageTiers, control, errors, item }) => {

  return (
    <>
      <div className="row-primary mt-3 mb-5 justify-content-center">
        <h2 className='fw-bold text-center text-uppercase'>Interpretation Rates</h2>
      </div>

      {languageTiers && languageTiers?.map((val, index) => {
        return (
          <div key={index} className='row-primary'>
            <h2 className='fw-bold text-uppercase'>{val?.name || val?.tiers[0]?.name || 'N/A'}</h2>

            <div>
              <h2 className='text-center my-3 fw-bold fst-italic'>Normal Hours*</h2>

              <div className='rate_container'>
                <div className="row-primary align-items-end">
                  <h2 className='mb-3 my-0'>Rates:</h2>
                  <div className='Inter_rate_row'>
                    <h4>OPI</h4>
                    <div className='inter_wrapper'>
                      <RateInput errors={errors} control={control} name={`interpretationRates.opi_normal_rate.${index}`} placeholder='OPI rate' currency_symbol={true} />
                      <UnitSelect control={control} name={`interpretationRates.opi_normal_rate_time_unit.${index}`} />
                    </div>
                  </div>

                  <div className='Inter_rate_row'>
                    <h4>VRI</h4>
                    <div className='inter_wrapper'>
                      <RateInput errors={errors} control={control} name={`interpretationRates.vri_normal_rate.${index}`} placeholder='VRI rate' currency_symbol={true} />
                      <UnitSelect control={control} name={`interpretationRates.vri_normal_rate_time_unit.${index}`} />
                    </div>
                  </div>

                  <div className='Inter_rate_row'>
                    <h4>In Person</h4>
                    <div className='inter_wrapper'>
                      <RateInput errors={errors} control={control} name={`interpretationRates.inperson_normal_rate.${index}`} placeholder='In person rate' currency_symbol={true} />
                      <UnitSelect control={control} name={`interpretationRates.inperson_normal_time_unit.${index}`} />
                    </div>
                  </div>
                </div>

                <div className="row-primary align-items-end">
                  <h2 className='mb-3 my-0'>Minimum (mins):</h2>
                  <div className='Inter_rate_row'>
                    <div className='inter_wrapper'>
                      <RateInput errors={errors} control={control} name={`interpretationRates.opi_normal_mins.${index}`} placeholder='OPI minimun mins' />
                      <UnitSelect control={control} name={`interpretationRates.opi_normal_mins_time_unit.${index}`} />
                    </div>
                  </div>

                  <div className='Inter_rate_row'>
                    <div className='inter_wrapper'>
                      <RateInput errors={errors} control={control} name={`interpretationRates.vri_normal_mins.${index}`} placeholder='VRI minimun mins' />
                      <UnitSelect control={control} name={`interpretationRates.vri_normal_mins_time_unit.${index}`} />
                    </div>
                  </div>

                  <div className='Inter_rate_row'>
                    <div className='inter_wrapper'>
                      <RateInput errors={errors} control={control} name={`interpretationRates.inperson_normal_mins.${index}`} placeholder='In person minimun mins' />
                      <UnitSelect control={control} name={`interpretationRates.inperson_normal_mins_time_unit.${index}`} />
                    </div>
                  </div>
                </div>
              </div>

              <h2 className='text-center my-3 fw-bold fst-italic'>After Hours*</h2>

              <div className='rate_container'>
                <div className="row-primary align-items-end">
                  <h2 className='mb-3 my-0'>Rates:</h2>
                  <div className='Inter_rate_row'>
                    <h4>OPI</h4>
                    <div className='inter_wrapper'>
                      <RateInput errors={errors} control={control} name={`interpretationRates.opi_after_rate.${index}`} placeholder='OPI rate' currency_symbol={true} />
                      <UnitSelect control={control} name={`interpretationRates.opi_after_rate_time_unit.${index}`} />
                    </div>
                  </div>

                  <div className='Inter_rate_row'>
                    <h4>VRI</h4>
                    <div className='inter_wrapper'>
                      <RateInput errors={errors} control={control} name={`interpretationRates.vri_after_rate.${index}`} placeholder='VRI rate' currency_symbol={true} />
                      <UnitSelect control={control} name={`interpretationRates.vri_after_rate_time_unit.${index}`} />
                    </div>
                  </div>

                  <div className='Inter_rate_row'>
                    <h4>In Person</h4>
                    <div className='inter_wrapper'>
                      <RateInput errors={errors} control={control} name={`interpretationRates.inperson_after_rate.${index}`} placeholder='In person rate' currency_symbol={true} />
                      <UnitSelect control={control} name={`interpretationRates.inperson_after_time_unit.${index}`} />
                    </div>
                  </div>
                </div>

                <div className="row-primary align-items-end">
                  <h2 className='mb-3 my-0'>Minimum (mins):</h2>
                  <div className='Inter_rate_row'>
                    <div className='inter_wrapper'>
                      <RateInput errors={errors} control={control} name={`interpretationRates.opi_after_mins.${index}`} placeholder='OPI minimun mins' />
                      <UnitSelect control={control} name={`interpretationRates.opi_after_mins_time_unit.${index}`} />
                    </div>
                  </div>

                  <div className='Inter_rate_row'>
                    <div className='inter_wrapper'>
                      <RateInput errors={errors} control={control} name={`interpretationRates.vri_after_mins.${index}`} placeholder='VRI minimun mins' />
                      <UnitSelect control={control} name={`interpretationRates.vri_after_mins_time_unit.${index}`} />
                    </div>
                  </div>

                  <div className='Inter_rate_row'>
                    <div className='inter_wrapper'>
                      <RateInput errors={errors} control={control} name={`interpretationRates.inperson_after_mins.${index}`} placeholder='In person minimun mins' />
                      <UnitSelect control={control} name={`interpretationRates.inperson_after_mins_time_unit.${index}`} />
                    </div>
                  </div>
                </div>
              </div>
              <br />
              <br />
              <br />
            </div>
          </div>
        )
      })}
    </>
  )
}
const TemplateForm = ({ item, loader, error }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { checkPermission } = usePermissions()
  const { templanguageTiers: languageTiers } = useSelector(languageTierSelector);
  const [tierId, setTierId] = useState([]);

  const interpretationRates =
  {
    tier_ids: languageTiers?.map((val) => val?.id) || [],
    opi_normal_rate: [],
    vri_normal_rate: [],
    inperson_normal_rate: [],
    opi_normal_rate_time_unit: [],
    vri_normal_rate_time_unit: [],
    inperson_normal_time_unit: [],
    opi_normal_mins: [],
    vri_normal_mins: [],
    inperson_normal_mins: [],
    opi_normal_mins_time_unit: [],
    vri_normal_mins_time_unit: [],
    inperson_normal_mins_time_unit: [],
    opi_after_rate: [],
    vri_after_rate: [],
    inperson_after_rate: [],
    opi_after_rate_time_unit: [],
    vri_after_rate_time_unit: [],
    inperson_after_time_unit: [],
    opi_after_mins: [],
    vri_after_mins: [],
    inperson_after_mins: [],
    opi_after_mins_time_unit: [],
    vri_after_mins_time_unit: [],
    inperson_after_mins_time_unit: [],
  }

  const methods = useForm({
    defaultValues: {
      interpretationRates,
    }
  });

  const { register, handleSubmit, watch, formState: { errors }, control, setValue, clearErrors, reset } = methods;
  const [status, setStatus] = useState(1);

  useEffect(() => {
    if (item?.id) return;
    reset({
      incremental: filterIncremental[0].value,
      interpretationRates: {
        tier_ids: languageTiers?.map((val) => val?.id) || [],
        opi_normal_rate: [],
        vri_normal_rate: [],
        inperson_normal_rate: [],
        opi_normal_rate_time_unit: languageTiers?.map(l => filterUnit[0].value) || [],
        vri_normal_rate_time_unit: languageTiers?.map(l => filterUnit[0].value) || [],
        inperson_normal_time_unit: languageTiers?.map(l => filterUnit[0].value) || [],
        opi_normal_mins: [],
        vri_normal_mins: [],
        inperson_normal_mins: [],
        opi_normal_mins_time_unit: languageTiers?.map(l => filterIncremental[0].value) || [],
        vri_normal_mins_time_unit: languageTiers?.map(l => filterIncremental[0].value) || [],
        inperson_normal_mins_time_unit: languageTiers?.map(l => filterIncremental[0].value) || [],
        opi_after_rate: [],
        vri_after_rate: [],
        inperson_after_rate: [],
        opi_after_rate_time_unit: languageTiers?.map(l => filterUnit[0].value) || [],
        vri_after_rate_time_unit: languageTiers?.map(l => filterUnit[0].value) || [],
        inperson_after_time_unit: languageTiers?.map(l => filterUnit[0].value) || [],
        opi_after_mins: [],
        vri_after_mins: [],
        inperson_after_mins: [],
        opi_after_mins_time_unit: languageTiers?.map(l => filterIncremental[0].value) || [],
        vri_after_mins_time_unit: languageTiers?.map(l => filterIncremental[0].value) || [],
        inperson_after_mins_time_unit: languageTiers?.map(l => filterIncremental[0].value) || [],
      }
    })

  }, [languageTiers, reset, item])

  useEffect(() => {
    if (item) {
      setTierId(
        item?.interpretation_rates?.map(val => val.tier_id)
      )
      dispatch(fetchTemplateLanguagesTiers(1, { ids: [...tierId] }));
    } else {
      dispatch(fetchTemplateLanguagesTiers());
    }
  }, [item])


  const resetAllFields = () => {
    setValue('name', '')
    setValue('normal_hour_start_time', '')
    setValue('normal_hour_end_time', '')
    setValue('after_hour_start_time', '')
    setValue('after_hour_end_time', '')
    setValue('grace_period', '')
    setValue('incremental', 'minute')
    setValue('rush_fee', '')
    setStatus(1)

    setValue('interpretationRates.vri_normal_rate', [])
    setValue('interpretationRates.inperson_normal_rate', [])
    setValue('interpretationRates.opi_normal_rate_time_unit', 'hour')
    setValue('interpretationRates.vri_normal_rate_time_unit', 'hour')
    setValue('interpretationRates.inperson_normal_time_unit', 'hour')
    setValue('interpretationRates.opi_normal_mins', [])
    setValue('interpretationRates.vri_normal_mins', [])
    setValue('interpretationRates.inperson_normal_mins', [])
    setValue('interpretationRates.opi_normal_mins_time_unit', 'minute')
    setValue('interpretationRates.vri_normal_mins_time_unit', 'minute')
    setValue('interpretationRates.inperson_normal_mins_time_unit', 'minute')

    setValue('interpretationRates.opi_after_rate', [])
    setValue('interpretationRates.vri_after_rate', [])
    setValue('interpretationRates.inperson_after_rate', [])
    setValue('interpretationRates.opi_after_rate_time_unit', 'hour')
    setValue('interpretationRates.vri_after_rate_time_unit', 'hour')
    setValue('interpretationRates.inperson_after_time_unit', 'hour')
    setValue('interpretationRates.opi_after_mins', [])
    setValue('interpretationRates.vri_after_mins', [])
    setValue('interpretationRates.inperson_after_mins', [])
    setValue('interpretationRates.opi_after_mins_time_unit', 'minute')
    setValue('interpretationRates.vri_after_mins_time_unit', 'minute')
    setValue('interpretationRates.inperson_after_mins_time_unit', 'minute')
  }

  useEffect(() => {
    setValue('name', item?.name || '')
    setValue('normal_hour_start_time', item?.normal_hour_start_time || '')
    setValue('normal_hour_end_time', item?.normal_hour_end_time || '')
    setValue('after_hour_start_time', item?.after_hour_start_time || '')
    setValue('after_hour_end_time', item?.after_hour_end_time || '')
    setValue('grace_period', item?.grace_period || '')
    setValue('incremental', item?.incremental || 'minute')
    setValue('rush_fee', item?.rush_fee || '')
    setStatus((typeof (item?.status) == "number") ? item?.status : 1)

    setValue('interpretationRates.opi_normal_rate', item?.interpretation_rates?.map(item => item.opi_normal_rate) || '')
    setValue('interpretationRates.vri_normal_rate', item?.interpretation_rates?.map(item => item.vri_normal_rate) || '')
    setValue('interpretationRates.inperson_normal_rate', item?.interpretation_rates?.map(item => item.inperson_normal_rate) || '')
    setValue('interpretationRates.opi_normal_rate_time_unit', item?.interpretation_rates?.map(item => item.opi_normal_rate_time_unit) || 'hour')
    setValue('interpretationRates.vri_normal_rate_time_unit', item?.interpretation_rates?.map(item => item.vri_normal_rate_time_unit) || 'hour')
    setValue('interpretationRates.inperson_normal_time_unit', item?.interpretation_rates?.map(item => item.inperson_normal_time_unit) || 'hour')
    setValue('interpretationRates.opi_normal_mins', item?.interpretation_rates?.map(item => item.opi_normal_mins) || '')
    setValue('interpretationRates.vri_normal_mins', item?.interpretation_rates?.map(item => item.vri_normal_mins) || '')
    setValue('interpretationRates.inperson_normal_mins', item?.interpretation_rates?.map(item => item.inperson_normal_mins) || '')
    setValue('interpretationRates.opi_normal_mins_time_unit', item?.interpretation_rates?.map(item => item.opi_normal_mins_time_unit) || 'minute')
    setValue('interpretationRates.vri_normal_mins_time_unit', item?.interpretation_rates?.map(item => item.vri_normal_mins_time_unit) || 'minute')
    setValue('interpretationRates.inperson_normal_mins_time_unit', item?.interpretation_rates?.map(item => item.inperson_normal_mins_time_unit) || 'minute')

    setValue('interpretationRates.opi_after_rate', item?.interpretation_rates?.map(item => item.opi_after_rate) || '')
    setValue('interpretationRates.vri_after_rate', item?.interpretation_rates?.map(item => item.vri_after_rate) || '')
    setValue('interpretationRates.inperson_after_rate', item?.interpretation_rates?.map(item => item.inperson_after_rate) || '')
    setValue('interpretationRates.opi_after_rate_time_unit', item?.interpretation_rates?.map(item => item.opi_after_rate_time_unit) || 'hour')
    setValue('interpretationRates.vri_after_rate_time_unit', item?.interpretation_rates?.map(item => item.vri_after_rate_time_unit) || 'hour')
    setValue('interpretationRates.inperson_after_time_unit', item?.interpretation_rates?.map(item => item.inperson_after_time_unit) || 'hour')
    setValue('interpretationRates.opi_after_mins', item?.interpretation_rates?.map(item => item.opi_after_mins) || '')
    setValue('interpretationRates.vri_after_mins', item?.interpretation_rates?.map(item => item.vri_after_mins) || '')
    setValue('interpretationRates.inperson_after_mins', item?.interpretation_rates?.map(item => item.inperson_after_mins) || '')
    setValue('interpretationRates.opi_after_mins_time_unit', item?.interpretation_rates?.map(item => item.opi_after_mins_time_unit) || 'minute')
    setValue('interpretationRates.vri_after_mins_time_unit', item?.interpretation_rates?.map(item => item.vri_after_mins_time_unit) || 'minute')
    setValue('interpretationRates.inperson_after_mins_time_unit', item?.interpretation_rates?.map(item => item.inperson_after_mins_time_unit) || 'minute')

    dispatch(setError({}));

    return () => {
      // resetAllFields()
    }
  }, [item])

  const submitCallback = (status, message) => {
    if (status) {
      toast.success(message, {
        className: "successToast",
      })
      resetAllFields()
      navigate(-1)
    }
    else {
      console.log('onSubmit', error)
      toast.error(message,
        {
          className: "errorToast",
        }
      );
    }
  };

  const onSubmit = (data) => {
    dispatch(setError({}))
    const newData = {
      ...data,
      ...data.interpretationRates,
      status,
    };
    delete data.interpretationRates;

    if (item?.id) {
      dispatch(updateTemplate(newData, item?.id, submitCallback));
    } else {
      dispatch(addTemplate(newData, submitCallback));
    }
  }


  return (
    <>
      <FormProvider {...methods}>
        <form className='card_table p-4' onSubmit={handleSubmit(onSubmit)}>


          <TemplateTimes control={control} errors={errors} error={error} watch={watch} setValue={setValue} languageTiers={languageTiers}/>

          <LanguageTiers languageTiers={languageTiers} control={control} errors={errors} item={item} />

          {checkPermission('Status Client Template') &&
            <div className="row-primary align-items-center">
              <h2 className='mt-0'>Status</h2>
              <CustomSwitch
                labelText="active"
                checked={status == 1 ? true : false}
                handleChange={(checked) => setStatus(checked ? 1 : 0)}
              />
            </div>
          }

          <div className="Form-footer">
            <SubmitButton
              loader={loader}
              btnText={item?.id ? "Update" : "Create"}
            />
          </div>
        </form>
      </FormProvider>
      {loader
        &&
        <FullPageLoader />
      }
    </>
  )
}

export default TemplateForm
